<template>
  <span>
    <!-- icon="md-pricetag" -->
    <Button class="ubtn_icon" shape="circle" size="small" @click="open"
      >医嘱遵守信息</Button
    >
    <Modal
      v-model="showWin"
      title="医嘱遵守信息"
      @on-cancel="cancel"
      width="700"
      footer-hide
    >
      <div class="tabooInfo">
        <patientName :info="info" />
        <Table :columns="columns1" :data="data1"></Table>
        <Page
          :total="total"
          :pageSize="pageSize"
          size="small"
          @on-change="pageChange"
        />
      </div>
    </Modal>
  </span>
</template>

<script>
import request from "@/utils/request.js";
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      showWin: false,
      columns1: [
        {
          title: "医嘱遵守情况",
          key: "record",
          minWidth: 200,
        },
        {
          title: "记录日期",
          key: "recordDate",
          width: 140,
        },
      ],
      data1: [],
    };
  },
  methods: {
    cancel() {},
    pageChange(index) {
      this.pageIndex = index;
      this.getData();
    },
    getData() {
      request
        .post("/kanghome/getMedicalAdviceData", {
          patientCode: this.info.patientCode,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        })
        .then((res) => {
          this.data1 = res.result;
          this.total = res.total;
        });
    },
    init() {
      this.getData();
    },
    open() {
      this.init();
      this.showWin = true;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.tabooInfo {
  height: 60vh;
  display: flex;
  flex-direction: column;
  :deep {
    .ivu-table-wrapper {
      height: 100%;
      margin-bottom: 10px;
    }
    .ivu-page {
    }
    .ivu-table {
      background: none;
      td {
        background: none;
        border-color: #ddd;
      }
      th {
        background: #ffffff66;
      }
    }
  }
}
</style>